import { Container, Typography } from '@design-system';
import React from 'react';
import './FileItem.scss';

export type FileItemProps = {
    title: string;
    icon: React.ReactNode;
    onClick: () => void;
    customRightIcon: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const FileItem: React.FC<FileItemProps> = ({ title, icon, onClick, customRightIcon, className, ...props }) => {
    return (
        <Container className={`file-item ${className}`} onClick={onClick} bordered="grey" padding="none" flexRow {...props}>
            <div className="file-item-content">
                {icon}
                <Typography intrinsic="p" color="marine">
                    {title}
                </Typography>
            </div>
            <div>{customRightIcon}</div>
        </Container>
    );
};
